<div class="dashboard-page">
  <div class="dashboard-content-grid">
    <main class="dashboard-main">
      <div class="dashboard-date-row">
        <div class="dateDisabled">
          <i class="fa-solid fa-calendar-days me-2"></i>
          <span>{{ time | date : "yyyy-MM-dd" : "UTC" }}</span>
        </div>
      </div>

      <div class="dashboard-container">
        <ng-template #dashboardsContent>
          <div [innerHTML]="htmlContent | safeHtml"></div>
        </ng-template>

        <ng-container *ngTemplateOutlet="dashboardsContent"></ng-container>
      </div>
    </main>

    <aside class="chart-library">
      <div class="chart-library-header">
        <h2>Chart Library</h2>
      </div>

      @for (section of chartLibrarySections; track section) {
        <div
          class="chart-library-section"
          [ngClass]="'chart-library-section-' + section.modifier"
          [class.chart-library-section-collapsed]="section.collapsed"
          >
          <button
            type="button"
            class="chart-library-section-header"
            (click)="toggleChartLibrarySection(section)"
            >
            <span>{{ section.title }}</span>
            <span class="chart-library-count">
              {{ section.items.length }}
            </span>
            <i
              class="far fa-angle-up chart-library-section-toggle"
              [ngClass]="{ collapsed: section.collapsed }"
            ></i>
          </button>
          @if (!section.collapsed) {
            @for (item of section.items; track item) {
              <button
                type="button"
                class="chart-library-item"
                (click)="toggleChartSelection(item.key)"
                [ngClass]="{ 'chart-selected': isChartSelected(item.key) }"
                >
                <span class="chart-library-preview">
                  <i class="fas fa-chart-pie"></i>
                </span>
                <span class="chart-library-item-text">
                  <span>{{ item.title }}</span>
                </span>
                <span class="chart-library-select-icon">
                  <i
                [class]="
                  isChartSelected(item.key)
                    ? 'fas fa-check-circle'
                    : 'far fa-circle'
                "
                  ></i>
                </span>
              </button>
            }
          }
        </div>
      }

    </aside>
  </div>
</div>
